import { useEffect, useState } from "react";

import { collection, onSnapshot, query, where } from "firebase/firestore";

import { firestore } from "../firebase/firebase";

import { mapAsistenciaSemaforo } from "../firebase/asistenciaSemaforoMapper";

const buildQuery = (vista) => {

  const asistencias = collection(firestore, "asistencias");

  if (vista === "fase1") return query(asistencias, where("EstatusID", "in", [1, 2]));

  if (vista === "fase2") return query(asistencias, where("EstatusID", "in", [3, 4, 5]));

  if (vista === "asignacion") return query(asistencias, where("EstatusID", "==", 2));

  if (vista === "escalamiento") return query(asistencias, where("EstatusID", "==", 2));

  if (vista === "seguimiento") return query(asistencias, where("EstatusID", "==", 3));

  throw new Error(`Consulta de semaforo desconocida: ${vista}`);

};

const useAsistenciasSemaforo = (vista) => {

  const [state, setState] = useState({ asistencias: [], loading: true, error: null });

  useEffect(() => {

    setState({ asistencias: [], loading: true, error: null });

    return onSnapshot(

      buildQuery(vista),

      (snapshot) => {

        setState({

          asistencias: snapshot.docs
            .map(mapAsistenciaSemaforo)
            .filter((asistencia) => asistencia.estatusFinalID === 1),

          loading: false,

          error: null,

        });

      },

      (error) => setState({ asistencias: [], loading: false, error })

    );

  }, [vista]);

  return state;

};

export const useSemaforoFase1 = () => useAsistenciasSemaforo("fase1");

export const useSemaforoFase2 = () => useAsistenciasSemaforo("fase2");

export const useSemaforoAsignacion = () => useAsistenciasSemaforo("asignacion");

export const useSemaforoEscalamiento = () => useAsistenciasSemaforo("escalamiento");

export const useSemaforoSeguimiento = () => useAsistenciasSemaforo("seguimiento");
